// ***** Remove Cameras Page for Camera Management *****
import "./Styling/RemoveCameras.css";
const RemoveCameras = () => {
  return (
    <div className="RemoveCameras">
      <h1> Remove Cameras</h1>
    </div>
  );
};

export default RemoveCameras;
